import React from 'react';
export const Home = React.lazy(() => import('./Home'));